import React from "react";
import { Row, Col } from "react-bootstrap";
import InstagramIcon from "../../shared/InstagramIcon";
import FacebookIcon from "../../shared/FacebookIcon";
import PhoneIcon from "../../shared/PhoneIcon";

export default function TeamSocials({ member }) {
  // Only show a row if the respective data exists
  const showPhone = member && member.phone_number;
  const showInstagram = member && member.instagram_name && member.instagram_url;
  const showFacebook = member && member.facebook_name && member.facebook_url;

  // If nothing to show, don't render the component
  if (!showPhone && !showInstagram && !showFacebook) {
    return null;
  }

  const handleClick = (type) => {
    if (type === "phone") {
      return null;
    }
    if (type === "instagram") {
      window.open(member.instagram_url);
    }
    if (type === "facebook") {
      window.open(member.facebook_url);
    }
  };

  return (
    <div className="team-socials mt-3">
      {showPhone && (
        <Row
          className="align-items-center social-row"
          onClick={() => {
            handleClick("phone");
          }}
        >
          <Col xs="auto" style={{ padding: "0", margin: "0" }}>
            <PhoneIcon />
          </Col>
          <Col style={{ padding: "0", margin: "0" }}>{member.phone_number}</Col>
        </Row>
      )}

      {showInstagram && (
        <Row
          className="align-items-center social-row"
          onClick={() => {
            handleClick("instagram");
          }}
        >
          <Col xs="auto" style={{ padding: "0", margin: "0" }}>
            <InstagramIcon />
          </Col>
          <Col style={{ padding: "0", margin: "0" }}>
            {member.instagram_name}
          </Col>
        </Row>
      )}

      {showFacebook && (
        <Row
          className="align-items-center social-row"
          onClick={() => {
            handleClick("facebook");
          }}
        >
          <Col xs="auto" style={{ padding: "0", margin: "0" }}>
            <FacebookIcon />
          </Col>
          <Col style={{ padding: "0", margin: "0" }}>
            {member.facebook_name}
          </Col>
        </Row>
      )}
    </div>
  );
}
